import React from "react";
import { Fragment } from "react";
import InfoCard from "./InfoCard";
import Rupees from "./Rupees";
import styled from "@emotion/styled";
import { getToFixedValue, isValueThere } from "Utils/index";

const FreightCalculationInfo = (props) => {
  const {
    isExtraChargeAccordionOpen,
    handleIsExtraChargeAccordionOpen,
    handleModalPopupOpen,
    details,
    firstMileDetails,
    lastMileDetails,
    sum_rail_freight_yard,
    total_rail_freight,
  } = props;
  return (
    <Fragment>
      <FreightCalculationInfoWrapper>
        <InfoCard
          isIconEnable={true}
          isIconRotate={isExtraChargeAccordionOpen}
          handleIsExtraChargeAccordionOpen={handleIsExtraChargeAccordionOpen}
          labelL1={"Rs. Per MT Freight (Calc)"}
          labelL2={`${getToFixedValue(details.per_mt_freight,2)} MT`}
        />

        {!!isExtraChargeAccordionOpen && (
          <AccordionWrapper>
            <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Basic Freight"}
              labelL2={<Rupees rate={details.basic_freight_rate} />}
              isTypeT1={true}
            />
            <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Source Charge"}
              labelL2={<Rupees rate={details.sur_charge} />}
              isTypeT1={true}
            />
            <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"NTR Charge"}
              labelL2={<Rupees rate={details.ntr_charge} />}
              isTypeT1={true}
            />
            <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Other Charge"}
              labelL2={<Rupees rate={details.other_charge} />}
              isTypeT1={true}
            />
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"DPO"}
              labelL2={<Rupees rate={"0.00"} />}
              isTypeT1={true}
            /> */}
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"FAUC"}
              labelL2={<Rupees rate={"0.00"} />}
              isTypeT1={true}
            /> */}
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Development Charges"}
              labelL2={<Rupees rate={"40.00"} />}
              isTypeT1={true}
            /> */}
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"TPRC"}
              labelL2={<Rupees rate={"0.00"} />}
              isTypeT1={true}
            /> */}
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Rebate"}
              labelL2={<Rupees rate={"0.00"} />}
              isTypeT1={true}
            /> */}
            <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Sum"}
              labelL2={<Rupees rate={details.per_mt_freight_sum} />}
              isActive={true}
            />
            {/* <InfoCard
              isleftPaddingEnabled={true}
              labelL1={"Rs. Per MT Freight (Calc)"}
              labelL2={<Rupees rate={"1147.00"} />}
              isActive={true}
            /> */}
          </AccordionWrapper>
        )}

        <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Insurance Policy Excess Clause"}
          labelL2={<Rupees rate={`${firstMileDetails.insurance_policy_charge} (per MT)`} />}
        />
        <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Port Haulage & Terminal Charges"}
          labelL2={<Rupees rate={`${firstMileDetails.terminal_charge} (per MT)`} />}
        />
        {/* <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Freight Rate from Plant to Yard"}
          labelL2={"2310 MT"}
          isActive={true}
          isClickable={true}
          onClickForInfoCard={handleModalPopupOpen}
        /> */}

        {isValueThere(firstMileDetails.first_mile_transporter) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Transporter at Railway Yard (First Mile)"}
            labelL2={<Rupees rate={`${firstMileDetails.first_mile_transporter} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}

        {isValueThere(firstMileDetails.first_mile_surveyor) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Surveyor at Railway Yard (First Mile)"}
            labelL2={<Rupees rate={`${firstMileDetails.first_mile_surveyor} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}
        {isValueThere(firstMileDetails.first_mile_handling) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Handling at Railway Yard (First Mile)"}
            labelL2={<Rupees rate={`${firstMileDetails.first_mile_handling} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}
        {isValueThere(firstMileDetails.first_mile_lashers) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Lasher at Railway Yard (First Mile)"}
            labelL2={<Rupees rate={`${firstMileDetails.first_mile_lashers} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}

        {isValueThere(lastMileDetails.last_mile_transporter) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Transportation Cost Yard to Depot (Last Mile)"}
            labelL2={<Rupees rate={`${lastMileDetails.last_mile_transporter} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}

        {isValueThere(lastMileDetails.last_mile_surveyor) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Surveyor at Railway Yard (Last Mile)"}
            labelL2={<Rupees rate={`${lastMileDetails.last_mile_surveyor} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}

        {isValueThere(lastMileDetails.last_mile_handling) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Handling at Railway Yard (Last Mile)"}
            labelL2={<Rupees rate={`${lastMileDetails.last_mile_handling} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}
        {isValueThere(lastMileDetails.last_mile_lashers) && (
          <InfoCard
            isleftPaddingEnabled={true}
            labelL1={"Lashers at Railway Yard (Last Mile)"}
            labelL2={<Rupees rate={`${lastMileDetails.last_mile_lashers} (per MT)`} />}
            // isActive={true}
            // isClickable={true}
            // onClickForInfoCard={handleModalPopupOpen}
          />
        )}

        {/* <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Handling at Railway Yard (Last Mile)"}
          labelL2={<Rupees rate={"2423471"} />}
          isActive={true}
          isClickable={true}
          onClickForInfoCard={handleModalPopupOpen}
        /> */}
        <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Total Rail Freight at Yard"}
          labelL2={<Rupees rate={sum_rail_freight_yard} />}
          isActive={true}
          // isClickable={true}
          // onClickForInfoCard={handleModalPopupOpen}
        />
        {/* <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Freight Rate from Yard to Depot"}
          labelL2={<Rupees rate={"1049"} />}
        /> */}
        <InfoCard
          isleftPaddingEnabled={true}
          labelL1={"Total Rail Freight"}
          labelL2={<Rupees rate={total_rail_freight} />}
          isActive={true}
          isTypeT2={true}
        />
      </FreightCalculationInfoWrapper>
    </Fragment>
  );
};

export default FreightCalculationInfo;

const FreightCalculationInfoWrapper = styled.div`
  border-radius: 5px;
  background: #f6f9ff;
  box-shadow: 0px 0px 8px 0px rgba(82, 138, 234, 0.24);
`;

const AdditionalFreightCalculationInfoWrapper = styled.div`
  background-color: #e7edfa;
`;

const Wrapper = styled.div`
  background-color: #e7edfa;
`;

const AccordionWrapper = styled.div`
  background-color: #e7edfa;
`;
